import { render, staticRenderFns } from "./warningType.vue?vue&type=template&id=cad92d9e&scoped=true&"
import script from "./warningType.vue?vue&type=script&lang=js&"
export * from "./warningType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad92d9e",
  null
  
)

export default component.exports